import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { setActiveSidebar } from '../../toolkit/sidebar/sidebarSlice';
import { routes } from '../../utils/constants/routes';
import { SellerSidebarOptions } from '../../utils/constants/sidebar';
import DashboardMainContainer from './DashboardMainContainer';
import { dashboardContainer } from './DashboardSx';
import CarsInNegotiation from './screens/CarsInNegotiation';
import LiveAuctionCars from './screens/LiveAuction';
import MyGarage from '@common/pages/Dashboard/screens/MyGarage';
import UpcomingCars from './screens/UpcomingCars';
import BuyNow from './screens/BuyNow';
import { CarEstimateAndAuctionForm } from '@common/pages/CarEstimate/CarEstimateAndAuctionForm.jsx';
import MyOrders from './screens/MyOrders';
// import { CarEstimateAndAuctionForm } from "@himanshusarma123/frontend_common";
import { findHighestCommonCharactersWithSingleString } from '@common/utils/methods/generalMethods';
import RejectedCars from './screens/RejectedCars';
import { reducerPaths } from 'src/app/reducerPaths';
import Profile from './screens/Profile';

const Dashboard = () => {
  // useLocation...
  const location = useLocation();
  // useLocation...

  // useDispatch...
  const dispatch = useDispatch();
  // useDispatch...

  const subPath = location?.pathname?.split?.(`${routes.dashboardNavigation}`)?.[1];

  const { activeSidebar } = useSelector((state) => state[reducerPaths.sidebar]);
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  // function findHighestCommonCharactersWithSingleString(arr, targetStr) {
  //   if (!Array.isArray(arr) || arr.length === 0 || typeof targetStr !== 'string') {
  //     return null; // Handle invalid inputs
  //   }

  //   let highestCount = 0;
  //   let result = null;

  //   // Use a Set to store unique characters of the target string for efficient lookup
  //   const targetChars = new Set(targetStr);

  //   for (const str of arr) {
  //     let commonCount = 0;
  //     // Use another Set to count common unique characters in the current array string
  //     const commonChars = new Set();

  //     for (const char of str) {
  //       if (targetChars.has(char)) {
  //         commonChars.add(char);
  //       }
  //     }

  //     commonCount = commonChars.size;

  //     if (commonCount > highestCount) {
  //       highestCount = commonCount;
  //       result = str;
  //     }
  //   }

  //   return result;
  // }

  const getActiveScreen = (subPath) => {
    switch (true) {
      // case SellerSidebarOptions[0].value: // "sellMyCar"
      //   return <SellMyCar />;
      case new RegExp(`^${routes.upcomingCars}(/\\d+)?$`).test(subPath):
        return <UpcomingCars />;
      case new RegExp(`^${routes.buyNow}(/\\d+)?$`).test(subPath):
        return <BuyNow />;
      case new RegExp(`^${routes.liveAuction}(/\\d+)?$`).test(subPath): // "liveAuction"
        return <LiveAuctionCars />;
      case new RegExp(`^${routes.carsInNegotiation}\\.*`).test(subPath) ||
        new RegExp(`^${routes.carsInNegotiationBuyNow}\\.*`).test(subPath): // "carsInNegotiation"
        return <CarsInNegotiation />;
      case new RegExp(`^${routes.carEstimate}\\.*`).test(subPath): // "liveAuction"
        return <CarEstimateAndAuctionForm />;
      // case SellerSidebarOptions[4].value: // "unsoldCars"
      //   return <UnsoldCars />;
      case RegExp(`^${routes.myGarage}\\.*`).test(subPath): // "myGarage"
        return <MyGarage />;
      case routes.rejectedCars === subPath:
        return <RejectedCars />;
      case new RegExp(`^${routes.myOrders}(/\\d+)?$`).test(subPath):
        return <MyOrders />;
      case routes.profile === subPath:
        return <Profile />;
      default: {
        navigate(`${routes.dashboardNavigation}${routes.myGarage}`);
      }
    }
  };

  React.useEffect(() => {
    const navigationRoutes = SellerSidebarOptions.map((option) => option.navigationRoute);

    const result = findHighestCommonCharactersWithSingleString(navigationRoutes, subPath);

    // if (result !== subPath) {
    //   navigate(`${routes.dashboardNavigation}${routes.myGarage}`);
    //   return;
    // }

    const toBeActiveSidebar = SellerSidebarOptions?.find((option) => {
      // return new RegExp(`${option?.navigationRoute}\\.*`).test(subPath);
      return option.navigationRoute === result;
    });

    console.log(toBeActiveSidebar, `toBeActiveSidebar`);
    if (!toBeActiveSidebar) {
      return;
    }

    dispatch(setActiveSidebar(toBeActiveSidebar));
  }, [subPath]);

  React.useEffect(() => {
    if (!subPath) {
      navigate(`${routes.dashboardNavigation}${routes.myGarage}`);
    }
  }, [subPath]);

  useEffect(() => {
    if (!token) {
      console.log(`notokennavigation`);
      // navigate(routes.authSignin);
      return;
    }
  }, [token, navigate]);

  return (
    <Box sx={dashboardContainer}>
      {/* <Sidebar
        sidebarOptions={SellerSidebarOptions}
      /> */}
      <DashboardMainContainer
        userRoleLabel={"Private seller"}
      >
        {getActiveScreen(subPath)}
      </DashboardMainContainer>
    </Box>
  );
};

export default Dashboard;
